import { j as s } from "./index.es33.js";
import { Icon as m } from "./index.es7.js";
import "./index.es93.js";
import "./index.es94.js";
import "./index.es95.js";
import "./index.es96.js";
import "./index.es97.js";
import "./index.es98.js";
import "./index.es99.js";
import "./index.es100.js";
import "./index.es101.js";
import "./index.es102.js";
import "./index.es103.js";
import "./index.es104.js";
import { palette as a } from "./index.es36.js";
import { PaginatorButton as c } from "./index.es569.js";
import r from "./index.es572.js";
var l = 5,
  k = function k(_ref) {
    var i = _ref.page,
      n = _ref.onPageClick,
      d = _ref.perPage,
      x = _ref.total;
    var p = function p() {
        i && n(i - 1);
      },
      j = function j() {
        i && n(i + 1);
      },
      o = Math.ceil(x / d),
      e = Array(l).fill(0).map(function (t, h) {
        return i - (i - 1) % l + h;
      }).filter(function (t) {
        return t <= o;
      });
    return s.jsxs("div", {
      className: r.container,
      children: [s.jsx(c, {
        onClick: p,
        className: r.paginatorButton,
        isDisabled: i === 1,
        isIcon: !0,
        children: s.jsx(m, {
          className: r.rotatedIconLeft,
          icon: m.icons.system.s.utilities.sortingUp,
          size: 16,
          color: a.gray10
        })
      }), o > l && e.includes(o) && s.jsxs(s.Fragment, {
        children: [s.jsx(c, {
          onClick: function onClick() {
            return n(1);
          },
          children: "1"
        }), s.jsx("div", {
          className: r.moreDots,
          children: "..."
        })]
      }), e.map(function (t) {
        return s.jsx(c, {
          onClick: function onClick() {
            return n(t);
          },
          isDisabled: t === i,
          children: t
        }, t);
      }), o > l && !e.includes(o) && s.jsxs(s.Fragment, {
        children: [s.jsx("div", {
          className: r.moreDots,
          children: "..."
        }), s.jsx(c, {
          onClick: function onClick() {
            return n(o);
          },
          children: o
        })]
      }), s.jsx(c, {
        onClick: j,
        className: r.paginatorButton,
        isIcon: !0,
        isDisabled: i === o,
        children: s.jsx(m, {
          className: r.rotatedIconRight,
          icon: m.icons.system.s.utilities.sortingUp,
          size: 16,
          color: a.gray10
        })
      })]
    });
  };
export { k as Paginator };